export default {
    headline: 'Request OTP',
    contact_number_lbl: 'Enter the 6 digits OTP sent via SMS on {0}',
    ref_code: 'Reference code : ',

    please_enter_otp: 'Please enter OTP',
    time_left: 'OTP expired in',
    second: 'minutes',

    required: 'Please enter your OTP.',
    too_short: 'Please enter otp',
    otp_timeout: 'OTP time out in',
    resend_otp: 'Resend OTP',

    incorrect_otp: 'OTP is incorrect. Please Try Again',
    cancel: "Cancel",
    btn_confirm: "Confirm"
}
